import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { CalendarDays, SearchIcon } from "lucide-react";
import { defaultColumns } from "../../constants/columns.constant";
import { useHolidays } from "@/common/hooks/queries/useHolidays";
import { Mapper } from "@/common/services/mapper";
import { HolidaysTransformer } from "../../services/holidaysTransformer";
import { HolidayData, HolidayTableItem } from "@/common/types/holidays";
import { DatePicker } from "@/common/components/ui/datePicker";

export default function Holidays() {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: holidays,
    meta,
    isPending: holidaysIsPending,
    isLoading: holidaysIsLoading,
    error: holidaysError = {} as any,
    refetch: refetchHolidays,
  } = useHolidays({
    filters: {
      search,
      page: filterParams.page || 1,
      date: filterParams.date
    },
    mapper: Mapper.mapWithTransformer<HolidayData[], HolidayTableItem[]>({
      transformer: HolidaysTransformer.tableTransformer()
    })
  });
  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<CalendarDays className="w-10 h-10" strokeWidth={1} />}
        title="Feriados"
        createButtonText="Novo feriado"
        dataTestid="create_holiday_button"
        operationKlassToCheckPermission="Admin::Calendar::Holidays::Create"
        disableCreateButton={holidaysIsPending || holidaysError?.status === 403}
      />

      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={holidaysError?.status}
        refetchFunction={refetchHolidays}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <TextField
            name="search"
            LeftIcon={<SearchIcon />}
            placeholder="Pesquisar"
            className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
            onChange={(e) => {
              setSearch((e.target as HTMLInputElement).value);
              setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
            }}
            value={filterParams.search}
          />
          <div className="flex flex-col gap-4">
            <DatePicker
              name=""
              date={filterParams.date && new Date(filterParams.date)}
              setDate={(date) => setFilterParams((prev) => ({ ...prev, date }))}
              className="max-w-40"
            />
          </div>

          <Table
            className="max-h-screen"
            columns={defaultColumns}
            isLoadingData={holidaysIsLoading}
            page={filterParams.page || 1}
            rows={holidays}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  )
}
